export default __webpack_public_path__ + "static/media/view4_month_place_.605b3e7b.csv";